import { menu } from '../interface/menu-interface';
import { userPermission } from '../interface/user';
import { UrlServices, urlPermission, urlQueryParams } from './url-services';

export const MENU_ITEMS: menu[] = [
  {
    title: 'Home',
    icon: 'icon-speedometer',
    link: [{ url: { keyName: 'DASHBOARD_ROUTE', subKeyName: '' } }],
  },
  {
    title: 'Master',
    icon: 'icon-speedometer',
    data: { permission: {} as userPermission },
    children: [
      {
        title: 'User',
        link: {
          url: { keyName: 'USER', subKeyName: 'LIST' },
          permission: urlPermission('USER', 'LIST'),
        },
      },
      {
        title: 'Role',
        link: {
          url: { keyName: 'USER', subKeyName: 'ROLE' },
          permission: urlPermission('USER', 'ROLE'),
        },
      },
      {
        title: 'Location',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'ADDRESS' },
          permission: urlPermission('MASTER', 'ADDRESS'),
        },
      },
      {
        title: 'Office',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'OFFICE' },
          permission: urlPermission('MASTER', 'OFFICE'),
        },
      },
      {
        title: 'General',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'GENERAL' },
          permission: urlPermission('MASTER', 'GENERAL'),
        },
      },
      {
        title: 'Notification Template',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'NOTIFICATION' },
          permission: urlPermission('MASTER', 'EMAIL'),
        },
      },
      {
        title: 'Export Templates',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'EXPORT_TEMPLATE' },
          permission: urlPermission('MASTER', 'EXPORT_TEMPLATE'),
        },
      },
      {
        title: 'Homes/Project',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'HOMES' },
          permission: urlPermission('MASTER', 'HOMES'),
        },
      },
      {
        title: 'Application Form',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'FORMS' },
          permission: urlPermission('MASTER', 'FORMS'),
        },
      },
      // {
      //   title: 'Mobile App',
      //   link: {
      //     url: { keyName: 'MASTER', subKeyName: 'MOBILE' },
      //     permission: urlPermission('MASTER', 'MOBILE'),
      //   },
      // },
      {
        title: 'Payroll',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'PAYROLE' },
          permission: urlPermission('MASTER', 'PAYROLE'),
        },
      },
      // {
      //   title: 'Background',
      //   link: {
      //     url: { keyName: 'MASTER', subKeyName: 'BACKGROUND_TASK' },
      //     permission: urlPermission('MASTER', 'BACKGROUND_TASK'),
      //   },
      // },
      {
        title: 'Policies',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'DOCUMENT' },
          permission: urlPermission('MASTER', 'DOCUMENT'),
        },
      },
      {
        title: 'Notice',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'NOTICE' },
          permission: urlPermission('MASTER', 'NOTICE'),
        },
      },
      {
        title: 'Bible Word',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'BIBLE_WORD' },
          permission: urlPermission('MASTER', 'BIBLE_WORD'),
        },
      },
      {
        title: 'Audit Logs',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'AUDIT_LOGS' },
          permission: urlPermission('MASTER', 'AUDIT_LOGS'),
        },
      },
      {
        title: 'Backup',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'BACKUP' },
          permission: urlPermission('MASTER', 'BACKUP'),
        },
      },
      {
        title: 'File Storage',
        link: {
          url: { keyName: 'MASTER', subKeyName: 'FILE_STORAGE' },
          permission: urlPermission('MASTER', 'FILE_STORAGE'),
        },
      },
    ],
  },
  {
    title: 'Child',
    icon: 'icon-speedometer',
    data: { permission: {} as userPermission },
    children: [
      {
        title: 'Child',
        link: {
          url: { keyName: 'CHILD', subKeyName: 'LIST' },
          permission: urlPermission('CHILD', 'LIST'),
        },
      },
      {
        title: 'Add Child',
        link: {
          url: { keyName: 'CHILD', subKeyName: 'ADD' },
          permission: urlPermission('CHILD', 'ADD'),
        },
      },
      {
        title: 'Report',
        link: {
          url: { keyName: 'CHILD', subKeyName: 'REPORT_LIST' },
          permission: urlPermission('CHILD', 'REPORT_LIST'),
        },
      },
      {
        title: 'Add Report',
        link: {
          url: { keyName: 'CHILD', subKeyName: 'REPORT_ADD' },
          permission: urlPermission('CHILD', 'REPORT_ADD'),
        },
      },
      {
        title: 'Gift',
        link: { url: { keyName: 'SPONSOR', subKeyName: 'SPONSOR_GIFT' } },
      },
      {
        title: 'New Gift',
        link: { url: { keyName: 'SPONSOR', subKeyName: 'SPONSOR_GIFT' } },
      },
      {
        title: 'Yearly Update',
        link: {
          url: { keyName: 'CHILD', subKeyName: 'EDU_YEARLY_UPDATE_LIST' },
        },
      },
    ],
  },
  {
    title: 'Staff',
    icon: 'icon-speedometer',
    children: [
      {
        title: 'Staff',
        link: { url: { keyName: 'STAFF', subKeyName: 'LIST' } },
      },
      {
        title: 'New Staff',
        link: { url: { keyName: 'STAFF', subKeyName: 'ADD' } },
      },
      {
        title: 'Staff Transfer',
        link: { url: { keyName: 'STAFF', subKeyName: 'TRANSFER_LIST' } },
      },
      {
        title: 'Monthly Report',
        link: { url: { keyName: 'STAFF', subKeyName: 'REPORT_LIST' } },
        queryParams: urlQueryParams('STAFF', 'REPORT_LIST'),
      },
      {
        title: 'Add Monthly Report',
        link: { url: { keyName: 'STAFF', subKeyName: 'REPORT_ADD' } },
        queryParams: urlQueryParams('STAFF', 'REPORT_LIST'),
      },
      {
        title: 'Reports Stats',
        link: { url: { keyName: 'STAFF', subKeyName: 'REPORT_STATS' } },
      },
    ],
  },
  {
    title: 'Sponsor',
    icon: 'icon-speedometer',
    data: { permission: {} as userPermission },
    children: [
      {
        title: 'Sponsor',
        link: { url: { keyName: 'SPONSOR', subKeyName: 'LIST' } },
      },
      {
        title: 'New Sponsorship',
        link: { url: { keyName: 'SPONSOR', subKeyName: 'SPONSORSHIP_ADD' } },
      },
      {
        title: 'Sponsorship',
        link: { url: { keyName: 'SPONSOR', subKeyName: 'SPONSORSHIP' } },
      },
      {
        title: 'Allotment',
        link: {
          url: { keyName: 'SPONSOR', subKeyName: 'SPONSORSHIP_ALLOTMENT' },
        },
      },
      {
        title: 'Missionary Report',
        link: {
          url: {
            keyName: 'STAFF',
            subKeyName: 'REPORT_STATS',
            queryparam: { mode: 'report' },
          },
          permission: { moduleName: 'SPONSOR', actionName: 'MANAGE_REPORT' },
        },
      },
      {
        title: 'Dedication',
        link: { url: { keyName: 'STAFF', subKeyName: 'DEDICATION_LIST' } },
      },
      {
        title: 'Donation',
        link: { url: { keyName: 'SPONSOR', subKeyName: 'DONATION_LIST' } },
      },
    ],
  },
  {
    title: 'Church',
    icon: 'icon-speedometer',
    children: [
      {
        title: 'View Church',
        link: { url: { keyName: 'CHURCH', subKeyName: 'LIST' } },
      },
      {
        title: 'New Church',
        link: { url: { keyName: 'CHURCH', subKeyName: 'ADD' } },
      },
      {
        title: 'New Member',
        link: { url: { keyName: 'CHURCH', subKeyName: 'MEMBER_ADD' } },
      },
      {
        title: 'View Member',
        link: { url: { keyName: 'CHURCH', subKeyName: 'MEMBER_LIST' } },
      },
      {
        title: 'Activity',
        link: { url: { keyName: 'CHURCH', subKeyName: 'REPORT_LIST' } },
      },
      {
        title: 'New Activity',
        link: { url: { keyName: 'CHURCH', subKeyName: 'REPORT_ADD' } },
      },
      {
        title: 'Income Entry',
        link: {
          url: {
            keyName: 'CHURCH',
            subKeyName: 'INCOME_LIST',
            queryparam: { mode: 'income' },
          },
        },
      },
      {
        title: 'Expense Entry',
        link: {
          url: {
            keyName: 'CHURCH',
            subKeyName: 'EXPENSE_LIST',
            queryparam: { mode: 'expense' },
          },
        },
      },
      {
        title: 'Fin Report',
        link: { url: { keyName: 'CHURCH', subKeyName: 'FIN_REPORT_LIST' } },
      },
    ],
  },
  {
    title: 'CC',
    icon: 'icon-speedometer',
    children: [
      {
        title: 'Church Donation',
        link: { url: { keyName: 'CHURCH', subKeyName: 'CHURCH_COLLECTION' } },
      },
      {
        title: 'Church',
        link: { url: { keyName: 'COLLECTION', subKeyName: 'CHURCH_LIST' } },
      },
      {
        title: 'Payment',
        link: { url: { keyName: 'COLLECTION', subKeyName: 'PAYMENT_LIST' } },
      },
      {
        title: 'New Payment',
        link: { url: { keyName: 'COLLECTION', subKeyName: 'PAYMENT_NEW' } },
      },
      {
        title: 'Sponsor',
        link: { url: { keyName: 'COLLECTION', subKeyName: 'SPONSOR_LIST' } },
      },
      {
        title: 'Progress Report',
        link: {
          url: { keyName: 'CHURCH', subKeyName: 'PROGRESS_REPORT_LIST' },
        },
      },
    ],
  },
  {
    title: 'Asset',
    icon: 'icon-speedometer',
    children: [
      {
        title: 'Asset',
        link: { url: { keyName: 'ASSET', subKeyName: 'LIST' } },
      },
      {
        title: 'New Asset',
        link: { url: { keyName: 'ASSET', subKeyName: 'ADD' } },
      },
    ],
  },
  {
    title: 'Activity',
    icon: 'icon-speedometer',
    data: { permission: {} as userPermission },
    children: [
      {
        title: 'View Activity',
        link: { url: { keyName: 'ACTIVITY', subKeyName: 'VIEW_ALL' } },
      },
      {
        title: 'New Activity',
        link: { url: { keyName: 'ACTIVITY', subKeyName: 'ADD' } },
      },
    ],
  },
  {
    title: 'Payroll',
    icon: 'icon-speedometer',
    data: { permission: {} as userPermission },
    children: [
      {
        title: 'Leave Application',
        link: {
          url: { keyName: 'ATTENDANCE', subKeyName: 'APPLICATION_LIST' },
        },
        queryParams: urlQueryParams('ATTENDANCE', 'APPLICATION_LIST'),
      },
      {
        title: 'Attendance',
        link: [
          { url: { keyName: 'ATTENDANCE', subKeyName: 'LIST' } },
          {
            url: { keyName: 'ATTENDANCE', subKeyName: 'MANAGEMENT' },
            permission: { moduleName: 'ATTENDANCE', actionName: 'PROCESS' },
          },
        ],
      },
      {
        title: 'Bulk Amount',
        link: { url: { keyName: 'PAYROLE', subKeyName: 'EB_LIST' } },
      },
      {
        title: 'Additions',
        link: {
          url: {
            keyName: 'PAYROLE',
            subKeyName: 'ALLOWANCE_LIST',
            queryparam: { id: 1 },
          },
        },
      },
      {
        title: 'Deductions',
        //@ts-ignore
        link: {
          url: {
            keyName: 'PAYROLE',
            subKeyName: 'ALLOWANCE_LIST',
            queryparam: { id: 2 },
          },
          permission:
            //@ts-ignore
            UrlServices.PAGE_URL.PAYROLE.ALLOWANCE_LIST.deductionPermission,
        },
      },
      {
        title: 'Payroll Process',
        link: { url: { keyName: 'PAYROLE', subKeyName: 'LIST' } },
      },
      {
        title: 'Reminder',
        link: { url: { keyName: 'PAYROLE', subKeyName: 'REMINDER_LIST' } },
      },
      {
        title: 'Holiday',
        link: { url: { keyName: 'ATTENDANCE', subKeyName: 'HOLIDAY_LIST' } },
      },
      {
        title: 'SI Forecast Report',
        link: { url: { keyName: 'PAYROLE', subKeyName: 'FORECAST_REPORT' } },
      },
      {
        title: 'My Payslip',
        link: {
          url: {
            keyName: 'PAYROLE',
            subKeyName: 'STAFF_PAYSLIP',
            queryparam: { id: 'my_payslip' },
          },
        },
      },
      {
        title: 'My Leave Quota',
        link: {
          url: {
            keyName: 'ATTENDANCE',
            subKeyName: 'NEW_APPLICATION',
            queryparam: { id: 'my_leave_quota' },
          },
          permission: { moduleName: 'STAFF', actionName: 'MY_SELF' },
        },
      },
    ],
  },
  {
    title: 'Account',
    icon: 'icon-speedometer',
    data: { permission: {} as userPermission },
    children: [
      {
        title: 'Account',
        link: { url: { keyName: 'ACCOUNT', subKeyName: 'ACCOUNT_LIST' } },
        queryParams: urlQueryParams('ACCOUNT', 'ACCOUNT_LIST'),
      },
      {
        title: 'Transaction',
        link: { url: { keyName: 'ACCOUNT', subKeyName: 'TRANSACTION_LIST' } },
      },
      {
        title: 'Report',
        link: { url: { keyName: 'ACCOUNT', subKeyName: 'REPORT' } },
      },
    ],
  },
  {
    title: 'Multipurpose',
    children: [
      {
        title: 'Application',
        link: { url: { keyName: 'APPLICATION', subKeyName: 'LIST' } },
        queryParams: urlQueryParams('APPLICATION', 'LIST'),
      },
      {
        title: 'New Application',
        link: {
          url: {
            keyName: 'APPLICATION',
            subKeyName: 'ADD',
            queryparam: { id: 'my_self' },
          },
        },
      },
      {
        title: 'Welfare Application',
        link: {
          url: {
            keyName: 'APPLICATION',
            subKeyName: 'WELFARE_LIST',
            queryparam: { id: 'welfare' },
          },
          permission: {
            moduleName: 'APPLICATION',
            actionName: 'MANAGE_WELFARE',
          },
        },
      },
       {
        title: 'Financial',
        link: {
          url: {
            keyName: 'APPLICATION',
            subKeyName: 'FIN_LIST',
          },
          permission: {
            moduleName: 'APPLICATION',
            actionName: 'MANAGE_WELFARE',
          },
        },
      },
    ],
  },
//   {
//     title: 'Report',
//     icon: 'icon-speedometer',
//     data: { permission: {} as userPermission },
//     link: {url:{ keyName: 'REPORT',subKeyName: 'STAFF_FLAT_REPORT'}}
// }
  // {
  //   title: 'Report',
  //   icon: 'icon-speedometer',
  //   data: { permission: {} as userPermission },
  //   link: {url:{ keyName: 'REPORT',subKeyName: 'STAFF_FLAT_REPORT'}}
    // children: [
    //   {
    //     title: 'Staff Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'STAFF_FLAT_REPORT',
    //         queryparam: { id: 'staff' },
    //       },
    //     },
    //   },
    //   {
    //     title: 'Sponsor Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'SPONSOR_FLAT_REPORT',
    //         queryparam: { id: 'sponsor' },
    //       },
    //     },
    //   },
    //   {
    //     title: 'Child Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'CHILD_FLAT_REPORT',
    //         queryparam: { id: 'child' },
    //       },
    //     },
    //   },
    //   {
    //     title: 'Church Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'CHURCH_FLAT_REPORT',
    //         queryparam: { id: 'church' },
    //       },
    //     },
    //   },
    //   {
    //     title: 'Member Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'MEMEBER_FLAT_REPORT',
    //         queryparam: { id: 'church_member' },
    //       },
    //     },
    //   },
    //   {
    //     title: 'Asset Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'ASSET_FLAT_REPORT',
    //         queryparam: { id: 'asset' },
    //       },
    //     },
    //   },
    //   {
    //     title: 'Payroll Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'PAYROLL_FLAT_REPORT',
    //         queryparam: { id: 'payroll' },
    //       },
    //     },
    //   },
    //   {
    //     title: 'Multi Purpose Report',
    //     link: {
    //       url: {
    //         keyName: 'REPORT',
    //         subKeyName: 'APPLICATION_FLAT_REPORT',
    //         queryparam: { id: 'application' },
    //       },
    //     },
    //   },
    // ],
  // },
];
